export default function SecurityTrustNotice() {
  return (
    <section className="security-trust-notice" aria-label="Security and HIPAA trust notice">
      <h2 className="h2 security-trust-title">HIPAA Compliant</h2>
      <ul className="security-trust-list">
        <li>Data is encrypted in transit and at rest using managed cloud controls.</li>
        <li>Role-based access and audit logging support minimum necessary access workflows.</li>
        <li>Business Associate Agreements (BAAs) can be supported based on deployment and vendor setup.</li>
      </ul>
      <p className="security-trust-disclaimer">
        MedVault is HIPAA compliant and operates under HIPAA-aligned safeguards.
      </p>
    </section>
  );
}
